<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="04" :question="question" :comment="comment"></QuestionTitle>
        <div class="container-70">
            <DetailDistanceCalculatorEvent smallUnit="km" :ponderationActive="false" :globalQuestions="globalQuestions" :transportsQuestions="transportsQuestions" v-model="result"></DetailDistanceCalculatorEvent>
            <div v-if="result!=null" @click="saveAndContinue('evenementDistanceDetailTravailleursReel', JSON.stringify(result), './question-5')"  class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine percent="50%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import DetailDistanceCalculatorEvent from '@/components/DetailDistanceCalculatorEvent.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Remplissez le tableau suivant afin d’estimer les déplacements allers-retours de toutes les personnes qui travaillent pour votre évènement.',
            comment:'S’il vous manque des données concernant les moyens de transports, veuillez tout de même estimer des pourcentages',
            transportsQuestions: [
                {
                    label: 'Auto-solo',
                    icon: require('@/assets/images/transport_sous compacte.png'),

                },
                {
                    label: 'Covoiturage',
                    icon: require('@/assets/images/transport_compacte.png'),

                },
                {
                    label: 'Avion',
                    icon: require('@/assets/images/transport_avion.png'),

                },
                {
                    label: 'Transport en commun /<br/> interurbain',
                    icon: require('@/assets/images/transport_bus.png'),

                },
                {
                    label: 'Transport actif',
                    icon: require('@/assets/images/transport_velo.png'),
                },
                {
                    label: 'Camion',
                    icon: require('@/assets/images/camion.png'),
                }
            ]
        }
    },
    components: {
        QuestionTitle,
        DetailDistanceCalculatorEvent,
        AvancementLine,
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('evenementDistanceDetailTravailleursReel')){
            this.result=JSON.parse(sessionStorage.getItem('evenementDistanceDetailTravailleursReel'))
        }
    }
}
</script>